// ================================================================
// Formatting utilities
// ================================================================

export function formatCurrency(amount: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

export function formatDateShort(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('es-MX', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDaysUntil(days: number): string {
  if (days === 0) return 'hoy';
  if (days === 1) return 'mañana';
  if (days === -1) return 'ayer';
  if (days < 0) return `hace ${Math.abs(days)} días`;
  if (days < 30) return `en ${days} días`;
  if (days < 60) return `en ~1 mes`;
  if (days < 365) return `en ~${Math.round(days / 30)} meses`;
  return `en ~${Math.round(days / 365)} años`;
}

export function urgencyLabel(urgency: string): string {
  const map: Record<string, string> = {
    overdue: 'Vencido',
    critical: 'Crítico',
    warning: 'Atención',
    normal: 'Al día',
    completed: 'Completado',
  };
  return map[urgency] || urgency;
}

export function jurisdictionLabel(j: string): string {
  const map: Record<string, string> = {
    federal: 'Federal · IRS',
    wyoming: 'Wyoming',
    multi_state: 'Multi-Estado',
    fincen: 'FinCEN',
  };
  return map[j] || j;
}

export function transactionTypeLabel(t: string): string {
  const map: Record<string, string> = {
    capital_contribution: 'Aportación de capital',
    distribution: 'Distribución al owner',
    loan_to_owner: 'Préstamo al owner',
    loan_from_owner: 'Préstamo del owner',
    service_payment_to_owner: 'Pago de servicios al owner',
    service_payment_from_owner: 'Pago de servicios del owner',
    interest_paid: 'Intereses pagados',
    interest_received: 'Intereses recibidos',
    other: 'Otra',
  };
  return map[t] || t;
}
